import React from 'react';

import { Pressable, ScrollView, Text, View } from 'react-native';
import User from '../object/User';

import { useEffect, useState } from 'react';
import { FONT_BOLD, FONT_REGULAR, getColor } from '../utils/theme';
import {
    NAVIGATION_BAR_HEIGHT,
    STATUS_BAR_HEIGHT,
    TAB_HEIGHT,
} from '../utils/screen';
import { Header } from '../component/Header';
import { t } from 'i18next';
import { GeSpinner } from '../component/GeSpinner';
import { height, isCloseToBottom } from '../utils/utils';
import useJTOState from '../utils/jto/useJTOState';
import Section from '../object/Section';
import { Select } from '../component/Select';
import JTOList from '../utils/jto/JTOList';
import { get } from '../utils/http';
import { HTTPUtils } from 'mp-ts-http';
import { applyResult } from '../utils/applyResult';

export const ExposantPage = (props: any) => {
    const [loading, setLoading] = useState(true);

    const event = useJTOState(User._instance.getEvent()!);

    const standList = useJTOState(User._instance.getEvent()!.stands);

    const [selectedSection, setSelectedSection] = useState<Section[]>([]);

    const [selectedSubSection, setSelectedSubSection] = useState<Section[]>([]);

    const filteredStandList = standList.getList().filter((stand) => {
        if (selectedSubSection.length > 0) {
            for (const selectedSub of selectedSubSection) {
                if (
                    stand.sectionList.find(
                        (elemSection) =>
                            elemSection.getJTOIdentifier() ===
                            selectedSub.getJTOIdentifier(),
                    )
                ) {
                    return true;
                }
            }
            return false;
        } else if (selectedSection.length > 0) {
            for (const selected of selectedSection) {
                if (
                    stand.sectionList.find(
                        (elemSection) =>
                            elemSection.getJTOIdentifier() ===
                            selected.getJTOIdentifier(),
                    )
                ) {
                    return true;
                }
            }
            return false;
        }
        return true;
    });

    const premiumStandList = filteredStandList.filter((stand) => {
        return stand.premium ?? false;
    });

    const nonPremiumStandList = filteredStandList.filter((stand) => {
        return !stand.premium;
    });

    useEffect(() => {
        standList.refetch(
            {
                event_id: event.getJTOIdentifier(),
            },
            (res) => {
                standList.setComplite(true);
            },
            (err) => {
                standList.setComplite(true);
            },
        );

        get('/event/section/list', { event_id: event.getJTOIdentifier() }).then(
            (res) => {
                if (HTTPUtils.isSuccess(res)) {
                    applyResult(HTTPUtils.getResult(res), event, true);
                }
            },
        );
    }, []);

    return (
        <View
            style={{
                width: '100%',
                height: '100%',
                backgroundColor: getColor('background'),
            }}
        >
            <Header
                backButton={true}
                title={t('exposant_list')}
                line={1}
                navigation={props.navigation}
                logo={event.logo.get() ?? ''}
                after={
                    <View
                        style={{
                            height: 10,
                        }}
                    ></View>
                }
            >
                {standList.isLoading() ? (
                    <View
                        style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            paddingBottom: NAVIGATION_BAR_HEIGHT + TAB_HEIGHT,
                            justifyContent: 'center',
                        }}
                    >
                        <GeSpinner color={getColor('primary')} />
                    </View>
                ) : standList.getList().length === 0 ? (
                    <ScrollView
                        style={{
                            flex: 1,
                            zIndex: 500,
                        }}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                    >
                        <View
                            style={{
                                height: 30,
                            }}
                        ></View>

                        <View
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingHorizontal: 20,
                                height:
                                    height() -
                                    TAB_HEIGHT -
                                    STATUS_BAR_HEIGHT -
                                    NAVIGATION_BAR_HEIGHT -
                                    150,
                                backgroundColor: getColor('background'),
                            }}
                        >
                            <Text
                                style={{
                                    color: getColor('text'),
                                    fontSize: 16,
                                    fontFamily: FONT_REGULAR,
                                    textAlign: 'center',
                                }}
                            >
                                {standList.size() === 0
                                    ? t('noStand')
                                    : standList.size()}
                            </Text>
                        </View>
                    </ScrollView>
                ) : (
                    <ScrollView
                        style={{
                            flex: 1,
                            zIndex: 500,
                        }}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                        onScroll={({ nativeEvent }) => {
                            if (isCloseToBottom(nativeEvent)) {
                                //standList.setComplite(false);
                                standList.more({
                                    event_id: event.getJTOIdentifier(),
                                });
                            }
                        }}
                        onMomentumScrollEnd={({ nativeEvent }) => {
                            if (isCloseToBottom(nativeEvent)) {
                                standList.more({
                                    event_id: event.getJTOIdentifier(),
                                });
                            }
                        }}
                    >
                        <View
                            style={{
                                height: 30,
                            }}
                        ></View>

                        <Select
                            onChange={(idList) => {
                                const tempList = [];
                                for (const id of idList) {
                                    const section = event.sectionList.find(
                                        (elem) =>
                                            elem.getJTOIdentifier() === id,
                                    );

                                    tempList.push(section);
                                }
                                setSelectedSection(tempList);
                            }}
                            placeholder='Choisissez une catégorie'
                            searchPlaceholder='Rechercher...'
                            list={event.sectionList.map((section) => {
                                return {
                                    label: section.name,
                                    value: section.getJTOIdentifier(),
                                };
                            })}
                        />

                        {selectedSection.length > 0 && (
                            <Select
                                onChange={(idList) => {
                                    const tempList = [];
                                    for (const id of idList) {
                                        let sub: Section;
                                        for (const section of selectedSection) {
                                            if (!sub) {
                                                sub =
                                                    section.subSectionList.find(
                                                        (elem) =>
                                                            elem.getJTOIdentifier() ===
                                                            id,
                                                    );
                                            }
                                        }
                                        tempList.push(sub);
                                    }
                                    setSelectedSubSection(tempList);
                                }}
                                placeholder='Choisissez une sous-catégorie'
                                searchPlaceholder='Rechercher...'
                                list={selectedSection.flatMap((section) => {
                                    return section.subSectionList.map((sub) => {
                                        return {
                                            label: sub.name,
                                            value: sub.getJTOIdentifier(),
                                        };
                                    });
                                })}
                            />
                        )}

                        {filteredStandList.length === 0 && (
                            <Text
                                style={{
                                    color: getColor('text'),
                                    fontSize: 16,
                                    fontFamily: FONT_REGULAR,
                                    textAlign: 'center',
                                }}
                            >
                                {t('noStand-category')}
                            </Text>
                        )}
                        {filteredStandList.length > 0 && (
                            <>
                                <Text
                                    style={{
                                        marginBottom: 20,
                                        textAlign: 'center',
                                        fontSize: 18,

                                        fontFamily: FONT_BOLD,
                                    }}
                                >
                                    {t('exposant')}
                                </Text>
                                <View
                                    style={{
                                        marginHorizontal: 20,
                                        marginBottom: 10,
                                    }}
                                >
                                    <View>
                                        {premiumStandList.map(
                                            (stand, index) => {
                                                return (
                                                    <Pressable
                                                        onPress={() => {
                                                            props.navigation.navigate(
                                                                'ExposantModal',
                                                                {
                                                                    event,
                                                                    stand,
                                                                },
                                                            );
                                                        }}
                                                        key={stand.getJTOIdentifier()}
                                                        style={{
                                                            borderRadius: 25,
                                                            marginBottom: 20,
                                                            backgroundColor:
                                                                'white',
                                                            shadowColor:
                                                                getColor(
                                                                    'hint',
                                                                ),
                                                            shadowOffset: {
                                                                width: 0,
                                                                height: 2,
                                                            },
                                                            shadowOpacity: 0.2,
                                                            shadowRadius: 3.84,
                                                            elevation: 5,
                                                        }}
                                                    >
                                                        <View
                                                            style={{
                                                                borderRadius: 24,
                                                                overflow:
                                                                    'hidden',
                                                            }}
                                                        >
                                                            <View
                                                                style={{
                                                                    backgroundColor:
                                                                        getColor(
                                                                            'primary',
                                                                        ),
                                                                    display:
                                                                        'flex',
                                                                    flexDirection:
                                                                        'row',
                                                                    padding: 10,
                                                                    alignItems:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Text
                                                                    style={{
                                                                        flex: 1,
                                                                        color: 'white',
                                                                        marginLeft: 10,
                                                                        fontSize: 20,
                                                                        fontFamily:
                                                                            FONT_BOLD,
                                                                    }}
                                                                >
                                                                    {stand
                                                                        .exposant
                                                                        .raisonSociale2 !==
                                                                    ''
                                                                        ? stand
                                                                              .exposant
                                                                              .raisonSociale1 +
                                                                          '\n' +
                                                                          stand
                                                                              .exposant
                                                                              .raisonSociale2
                                                                        : stand
                                                                              .exposant
                                                                              .raisonSociale1}
                                                                </Text>
                                                            </View>
                                                            <View
                                                                style={{
                                                                    padding: 10,
                                                                }}
                                                            >
                                                                {stand.sectionList
                                                                    .filter(
                                                                        (
                                                                            value,
                                                                        ) => {
                                                                            return value.position;
                                                                        },
                                                                    )
                                                                    .map(
                                                                        (
                                                                            section: Section,
                                                                        ) => {
                                                                            return (
                                                                                <Text
                                                                                    style={{
                                                                                        flex: 1,
                                                                                        color: 'black',
                                                                                        marginLeft: 10,

                                                                                        fontSize: 15,
                                                                                        fontFamily:
                                                                                            FONT_REGULAR,
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        section.name
                                                                                    }
                                                                                </Text>
                                                                            );
                                                                        },
                                                                    )}
                                                            </View>
                                                        </View>
                                                    </Pressable>
                                                );
                                            },
                                        )}

                                        {nonPremiumStandList.map(
                                            (stand, index) => {
                                                return (
                                                    <Pressable
                                                        onPress={() => {
                                                            props.navigation.navigate(
                                                                'ExposantModal',
                                                                {
                                                                    event,
                                                                    stand,
                                                                },
                                                            );
                                                        }}
                                                        key={stand.getJTOIdentifier()}
                                                        style={{
                                                            borderRadius: 25,
                                                            marginBottom: 20,
                                                            backgroundColor:
                                                                'white',
                                                            shadowColor:
                                                                getColor(
                                                                    'hint',
                                                                ),
                                                            shadowOffset: {
                                                                width: 0,
                                                                height: 2,
                                                            },
                                                            shadowOpacity: 0.2,
                                                            shadowRadius: 3.84,
                                                            elevation: 5,
                                                        }}
                                                    >
                                                        <View
                                                            style={{
                                                                borderRadius: 24,
                                                                overflow:
                                                                    'hidden',
                                                            }}
                                                        >
                                                            <View
                                                                style={{
                                                                    backgroundColor:
                                                                        getColor(
                                                                            'primary',
                                                                        ),
                                                                    display:
                                                                        'flex',
                                                                    flexDirection:
                                                                        'row',
                                                                    padding: 10,
                                                                    alignItems:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Text
                                                                    style={{
                                                                        flex: 1,
                                                                        color: 'white',
                                                                        marginLeft: 10,
                                                                        fontSize: 20,
                                                                        fontFamily:
                                                                            FONT_BOLD,
                                                                    }}
                                                                >
                                                                    {stand
                                                                        .exposant
                                                                        .raisonSociale2 !==
                                                                    ''
                                                                        ? stand
                                                                              .exposant
                                                                              .raisonSociale1 +
                                                                          '\n' +
                                                                          stand
                                                                              .exposant
                                                                              .raisonSociale2
                                                                        : stand
                                                                              .exposant
                                                                              .raisonSociale1}
                                                                </Text>
                                                            </View>
                                                            <View
                                                                style={{
                                                                    padding: 10,
                                                                }}
                                                            >
                                                                {stand.sectionList
                                                                    .filter(
                                                                        (
                                                                            value,
                                                                        ) => {
                                                                            return value.position;
                                                                        },
                                                                    )
                                                                    .map(
                                                                        (
                                                                            section: Section,
                                                                        ) => {
                                                                            return (
                                                                                <Text
                                                                                    style={{
                                                                                        flex: 1,
                                                                                        color: 'black',
                                                                                        marginLeft: 10,

                                                                                        fontSize: 15,
                                                                                        fontFamily:
                                                                                            FONT_REGULAR,
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        section.name
                                                                                    }
                                                                                </Text>
                                                                            );
                                                                        },
                                                                    )}
                                                            </View>
                                                        </View>
                                                    </Pressable>
                                                );
                                            },
                                        )}
                                    </View>
                                </View>
                            </>
                        )}

                        <View
                            style={{
                                height: STATUS_BAR_HEIGHT,
                            }}
                        />
                    </ScrollView>
                )}
            </Header>
        </View>
    );
};
